<template>
  <!-- Authors Table Card -->
  <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: '20px' }">
    <a-row :gutter="24" type="flex">
      <!-- Authors Table Column -->
      <a-col :span="24" class="mb-24">
        <a-form layout="inline" :form="dataForm" @submit="getDataList" class="p-20">
          <a-form-item label="分类名称">
            <a-input v-model="dataForm.title" placeholder="分类名称" />
          </a-form-item>
          <a-form-item label="状态">
            <a-select v-model="dataForm.state" allowClear style="width: 120px;" placeholder="状态">
              <a-select-option value="1">启用</a-select-option>
              <a-select-option value="2">禁用</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="addOrUpdateHandle()">新增导航栏</a-button>
          </a-form-item>
        </a-form>

        <a-table :columns="columns" :data-source="dataList" :pagination="false" rowKey="navid"
          :loading="dataListLoading">
          <template slot="state" slot-scope="state">
            <a-tag :color="state === '1' ? 'green' : 'red'">{{ state === '1' ? '启用' : '禁用' }}</a-tag>
          </template>
          <template slot="editBtn" slot-scope="text, row">
            <a-button type="link" class="btn-edit" @click="addOrUpdateHandle(row.navid)">
              编辑
            </a-button>
            <!-- <a-button type="link" class="btn-edit" @click="deleteHandle(row.navid)">
              删除
            </a-button> -->
          </template>
        </a-table>
      </a-col>
      <!-- / Authors Table Column -->
    </a-row>

    <a-pagination class="mr-20 float-right" show-size-changer :current="page" :total="total"
      :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange" @change="pageCurrentChangeHandle" />
    <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
  </a-card>
  <!-- / Authors Table Card -->
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/addorupdate.vue";
export default {
  mixins: [viewModule],
  components: {
    addorupdate,
  },
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/admin/appnav/page",
        deleteURL: "/admin/appnav/delete",
      },
      expandedRowKeys: [],
      dataForm: {
        title: "",
        state: '1',
      },
      columns: [
        {
          title: "导航栏名称",
          dataIndex: "title",
          width: 300
        },
        {
          title: "排序",
          dataIndex: "sort",
          width: 200
        },
        {
          title: "状态",
          dataIndex: "state",
          width: 200,
          scopedSlots: { customRender: "state" },
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          width: 180
        },
        {
          title: "操作",
          scopedSlots: { customRender: "editBtn" },
          width: 250,
          fixed: "right",
        },
      ],
    };
  },
};
</script>